/* eslint-disable prettier/prettier */

export const TOKEN = "token";
export const TEN_MILLION = 10_000_000;
export const GAME_NAMES = {
    donuts: "Solitaire",
};
export const PAYMENT_METHOD = "payment-method";
export const PAYMENT_COIN_FLOW = "coin-flow";
export const PAYMENT_SEAMLESS = "seamless";

// Community feed. The new contract uses a single like/unlike reaction, so the
// previous multi-emoji COMMUNITY_REACTIONS list was removed.
export const COMMUNITY_POST_CHAR_LIMIT = Number(
    process.env.GATSBY_COMMUNITY_POST_CHAR_LIMIT || 500
);

export const FIREBASE_ERROR_MESSAGES = {
    "auth/admin-restricted-operation": "Admin restricted operation.",
    "auth/argument-error": "Something went wrong. Please try again.",
    "auth/app-not-authorized": "This app is not authorized.",
    "auth/app-not-installed": "App not installed.",
    "auth/captcha-check-failed": "CAPTCHA check failed. Please try again.",
    "auth/code-expired": "The code has expired.",
    "auth/cordova-not-ready": "Cordova is not ready.",
    "auth/cors-unsupported": "CORS is unsupported.",
    "auth/credential-already-in-use": "Credential is already in use.",
    "auth/custom-token-mismatch": "Token mismatch. Please try again.",
    "auth/requires-recent-login": "Session expired. Please log in again.",
    "auth/dependent-sdk-initialized-before-auth":
        "Please initialize the SDK before authentication.",
    "auth/dynamic-link-not-activated": "Dynamic link is not activated.",
    "auth/email-change-needs-verification":
        "Please verify your new email address.",
    "auth/email-already-in-use": "This email is already in use.",
    "auth/emulator-config-failed": "Emulator configuration failed.",
    "auth/expired-action-code": "This link has expired.",
    "auth/cancelled-popup-request": "The popup request was cancelled.",
    "auth/internal-error": "Something went wrong. Please try again.",
    "auth/invalid-api-key": "Invalid API key.",
    "auth/invalid-app-credential": "Invalid app credential.",
    "auth/invalid-app-id": "Invalid app ID.",
    "auth/invalid-user-token": "Your session is invalid. Please log in again.",
    "auth/invalid-auth-event": "Invalid authentication event.",
    "auth/invalid-cert-hash": "Invalid certificate hash.",
    "auth/invalid-verification-code": "Invalid verification code.",
    "auth/invalid-continue-uri": "Invalid continue URL.",
    "auth/invalid-cordova-configuration": "Invalid Cordova configuration.",
    "auth/invalid-custom-token": "Invalid custom token.",
    "auth/invalid-dynamic-link-domain": "Invalid dynamic link domain.",
    "auth/invalid-email": "Invalid email address.",
    "auth/invalid-emulator-scheme": "Invalid emulator scheme.",
    "auth/invalid-credential": "Incorrect email or password.",
    "auth/invalid-message-payload": "Invalid message payload.",
    "auth/invalid-multi-factor-session": "Invalid multi-factor session.",
    "auth/invalid-oauth-client-id": "Invalid OAuth client ID.",
    "auth/invalid-oauth-provider": "Invalid OAuth provider.",
    "auth/invalid-action-code": "This link is invalid.",
    "auth/unauthorized-domain": "This domain is not authorized.",
    "auth/wrong-password": "Incorrect password.",
    "auth/invalid-persistence-type": "Invalid persistence type.",
    "auth/invalid-phone-number": "Invalid phone number.",
    "auth/invalid-provider-id": "Invalid provider ID.",
    "auth/invalid-recipient-email": "Invalid recipient email.",
    "auth/invalid-sender": "Invalid sender.",
    "auth/invalid-verification-id": "Invalid verification ID.",
    "auth/invalid-tenant-id": "Invalid tenant ID.",
    "auth/multi-factor-info-not-found": "Multi-factor info not found.",
    "auth/multi-factor-auth-required": "Multi-factor authentication required.",
    "auth/missing-android-pkg-name": "Android package name is missing.",
    "auth/missing-app-credential": "App credential is missing.",
    "auth/auth-domain-config-required": "Auth domain config is missing.",
    "auth/missing-verification-code": "Verification code is missing.",
    "auth/missing-continue-uri": "Continue URL is missing.",
    "auth/missing-iframe-start": "iFrame start is missing.",
    "auth/missing-ios-bundle-id": "iOS bundle ID is missing.",
    "auth/missing-or-invalid-nonce": "Invalid or missing nonce.",
    "auth/missing-multi-factor-info": "Multi-factor info is missing.",
    "auth/missing-multi-factor-session": "Multi-factor session is missing.",
    "auth/missing-phone-number": "Phone number is missing.",
    "auth/missing-verification-id": "Verification ID is missing.",
    "auth/app-deleted": "This app has been deleted.",
    "auth/account-exists-with-different-credential":
        "An account already exists with this email.",
    "auth/network-request-failed": "Network error. Check your connection.",
    "auth/null-user": "No user is signed in.",
    "auth/no-auth-event": "No authentication event found.",
    "auth/no-such-provider": "This provider is not linked to your account.",
    "auth/operation-not-allowed": "This operation is not allowed.",
    "auth/operation-not-supported-in-this-environment":
        "Operation not supported in this environment.",
    "auth/popup-blocked": "Popup was blocked by the browser.",
    "auth/popup-closed-by-user": "Popup was closed before completing.",
    "auth/provider-already-linked": "This provider is already linked.",
    "auth/quota-exceeded": "Quota exceeded. Try again later.",
    "auth/redirect-cancelled-by-user": "Redirect was cancelled.",
    "auth/redirect-operation-pending":
        "A redirect operation is already pending.",
    "auth/rejected-credential": "Credential was rejected.",
    "auth/second-factor-already-in-use":
        "This second factor is already enrolled.",
    "auth/maximum-second-factor-count-exceeded": "Second factor limit reached.",
    "auth/tenant-id-mismatch": "Tenant ID mismatch.",
    "auth/timeout": "The request timed out.",
    "auth/user-token-expired": "Your session has expired. Please log in again.",
    "auth/too-many-requests": "Too many attempts. Try again later.",
    "auth/unauthorized-continue-uri": "This domain is not authorized.",
    "auth/unsupported-first-factor": "This sign-in method is not supported.",
    "auth/unsupported-persistence-type": "Unsupported persistence type.",
    "auth/unsupported-tenant-operation":
        "This operation is not supported for tenants.",
    "auth/unverified-email": "Please verify your email first.",
    "auth/user-cancelled": "Action was cancelled.",
    "auth/user-not-found": "No account found with this email.",
    "auth/user-disabled": "This account has been disabled.",
    "auth/user-mismatch": "This credential does not match the current user.",
    "auth/user-signed-out": "You have been signed out.",
    "auth/weak-password": "Password is too weak.",
    "auth/web-storage-unsupported":
        "Web storage is not supported by this browser.",
    "auth/already-initialized": "Auth is already initialized.",
    "auth/recaptcha-not-enabled": "reCAPTCHA is not enabled.",
    "auth/missing-recaptcha-token": "reCAPTCHA token is missing.",
    "auth/invalid-recaptcha-token": "Invalid reCAPTCHA token.",
    "auth/invalid-recaptcha-action": "Invalid reCAPTCHA action.",
    "auth/missing-client-type": "Client type is missing.",
    "auth/missing-recaptcha-version": "reCAPTCHA version is missing.",
    "auth/invalid-recaptcha-version": "Invalid reCAPTCHA version.",
    "auth/invalid-req-type": "Invalid request type.",
    "auth/invalid-hosting-link-domain": "Invalid hosting link domain.",
};
